import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Link from "../../link"

export default function CardStoriesHomePageES() {
  /**
   * Utility for adding a common query param to the thumbnail images.
   * There's a bug with handling this in CosmicJS.
   * @param url
   * @returns {string}
   */
  const imgixUrl = url => {
    const q = "?q=&auto=compress,&w=712&h=446&fit=crop&crop=faces"
    return url + q
  }

  return (
    <StaticQuery
      query={graphql`
        {
          allCosmicjsStories(
            limit: 3
            filter: {
              locale: { in: ["es-ES"] }
              metadata: { story_display_on_homepage: { eq: true } }
            }
          ) {
            edges {
              node {
                id
                title
                slug
                metadata {
                  story_job_title
                  story_company
                  story_quote
                  story_personal_photo {
                    imgix_url
                  }
                }
              }
            }
          }
        }
      `}
      render={data =>
        data.allCosmicjsStories.edges.map(({ node }, idx) => {
          return (
            <div className="component-card component-card-stories" key={idx}>
              <div className="component-card-image component-card-image-stories">
                <Link
                  className="component-card-title component-card-title-stories"
                  to={`/story/${node.slug}`}
                >
                  <img
                    src={imgixUrl(node.metadata.story_personal_photo?.imgix_url)}
                    alt="story"
                  />
                </Link>
              </div>
              <div className="component-card-meta component-card-meta-stories">
                <div className="component-card-meta-header component-card-meta-header-stories">
                  <Link
                    className="component-card-title component-card-title-stories"
                    to={`/story/${node.slug}`}
                  >
                    {node.metadata.story_job_title}
                  </Link>
                </div>
                <div className="component-card-company component-card-company-stories">
                  {node.metadata.story_company}
                </div>
                <blockquote className="component-blockquote component-blockquote-stories">
                  <p>&ldquo;{node.metadata.story_quote}&rdquo;</p>
                  <cite>&mdash; {node.title}</cite>
                </blockquote>
              </div>
            </div>
          )
        })
      }
    />
  )
}
